import { render, staticRenderFns } from "./OverlayOutofStock.vue?vue&type=template&id=2c106e57&scoped=true&"
import script from "./OverlayOutofStock.vue?vue&type=script&lang=js&"
export * from "./OverlayOutofStock.vue?vue&type=script&lang=js&"
import style0 from "./OverlayOutofStock.vue?vue&type=style&index=0&id=2c106e57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c106e57",
  null
  
)

export default component.exports